import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

//加载动画样式
import "animate.css";
import "@/assets/css/tailwind.css";

const app = createApp(App);

//#region 加载element ui
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import "element-plus/dist/index.css";
import zhCn from "element-plus/es/locale/lang/zh-cn";

//初始化主题颜色
import { initThemeColor } from "./utils/theme";

//打印组件
import print from "vue3-print-nb";

import ElementPlus, {
  ElTable,
  dayjs,
  ElSelect,
  ElInputNumber,
  ElDialog,
} from "element-plus";

ElTable.props.className = { type: String, default: "c-table" }; //设置列表样式
ElTable.props.headerCellStyle = {
  type: Object,
  default: {
    background: "#F7F7F7",
    color: "#000",
  },
}; //表头背景
ElTable.props.style = {
  type: Object,
  default: {
    "--el-border-color-lighter": "#f9f9f9",
  },
}; //设置表格间隔边框颜色
ElTable.props.showOverflowTooltip = { type: Boolean, default: true }; //设置tooltip
ElSelect.props.clearable = { type: Boolean, default: true }; //设置下拉框可清空
ElSelect.props.filterable = { type: Boolean, default: true }; //设置下拉框可搜索

ElInputNumber.props.controls = { type: Boolean, default: false }; //设置输入框不显示左右按钮

ElDialog.props.closeOnClickModal = { type: Boolean, default: false }; //点击遮罩层不关闭
// ElDialog.props.appendToBody = { type: Boolean, default: true }; //dialog挂载到body
ElDialog.props.alignCenter = { type: Boolean, default: true }; //上下居中
ElDialog.props.destroyOnClose = { type: Boolean, default: true }; //关闭时销毁其中的元素
ElDialog.props.draggable = { type: Boolean, default: true }; //可拖拽对话框
ElDialog.props.overflow = { type: Boolean, default: true }; //可拖拽至屏幕外
ElDialog.props.modal = { type: Boolean, default: false }; //模态框配置-无遮罩层，允许操作底层页面
ElDialog.props.modalPenetrable = { type: Boolean, default: true }; //模态框配置-无遮罩层，允许操作底层页面

//配置element图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.config.globalProperties[key] = key;
  app.component(key, component);
}
//#endregion

//#region 路由拦截
router.beforeEach((to, from, next) => {
  if (["/login"].includes(to.path)) {
    next();
  } else {
    let token = localStorage.getItem("token");
    if (token) {
      next();
    } else {
      next({
        path: "/login",
      });
    }
  }
});

router.afterEach(() => {});
//#endregion

//#region 注入分页控件模板
import cPage from "@/components/Page.vue";
app.component("c_page", cPage);
//#endregion

//#region 注入状态模板
import cStatus from "@/components/Status.vue";
app.component("c_status", cStatus);
//#endregion

//#region 表格行内显示两行内容
import cTabgroup from "@/components/TabGroup.vue";
app.component("c_tabgroup", cTabgroup);
//#endregion

//#region 自定义单元格
import cCell from "@/components/Cell.vue";
app.component("c_cell", cCell);
//#endregion

//#region 自定义金额组件
import cMoney from "@/components/Money.vue";
app.component("c_money", cMoney);
//#endregion

//#region 自定义富文本编辑器
import cEditor from "@/components/Editor.vue";
app.component("c_editor", cEditor);
//#endregion

//#region 自定义选择用户组件
import cUserSelect from "@/components/UserSelect.vue";
app.component("c_userselect", cUserSelect);
//#endregion

//#region 自定义通用标题组件
import cTitles from "@/components/Titles.vue";
app.component("c_titles", cTitles);
//#endregion

//#region 自定义地图组件
import cMap from "@/components/Map.vue";
app.component("c_map", cMap);
//#endregion

//#region 自定义性别组件
import cSex from "@/components/Sex.vue";
app.component("c_sex", cSex);
//#endregion

//#region 自定义查询条件组件
import cParams from "@/components/Params.vue";
app.component("c_params", cParams);
//#endregion

//#region 自定义布尔值转是否组件
import c_BoolText from "@/components/BoolText.vue";
app.component("c_BoolText", c_BoolText);
//#endregion

//#region 自定义头像组件
import c_Avatar from "@/components/Avatar.vue";
app.component("c_Avatar", c_Avatar);
//#endregion

//#region 自定义上传文件
import c_UploadFile from "@/components/UploadFile.vue";
app.component("c_UploadFile", c_UploadFile);
//#endregion

//#region 统计数字组件
import c_statistics from "@/components/Statistics.vue";
app.component("c_statistics", c_statistics);
//#endregion

//#region 日程详情
import c_HuiYiDetailRiChengDetail from "@/views/HuiYi/Detail/RiCheng/Detail.vue";
app.component("c_HuiYiDetailRiChengDetail", c_HuiYiDetailRiChengDetail);
store.commit("setCompontents", "c_HuiYiDetailRiChengDetail");
//#endregion

//#region 注入404页面
import c_404 from "@/views/Home/404.vue";
app.component("c_404", c_404);
//#endregion

//#region 注册全部组件
const requireComponent = require.context("./views", true, /\.vue$/);
requireComponent.keys().forEach((fileName) => {
  // 当前组件
  const config = requireComponent(fileName);
  //获取组件名
  const componentName =
    "c_" +
    fileName
      .replace(/^\.\//, "")
      .replace(/\.\w+$/, "")
      .replace("/", ""); // 第一个replace(/^\.\//, '')去掉前面的./   第二个replace(/\.W+$/)是去掉后面的.vue

  store.commit("setCompontents", componentName);
  // 参数一： 组件名
  // 参数二： config：是一整个组件的内容；  config.default：是组件中export.default里面的内容
  app.component(componentName, config.default || config);
});
//#endregion

//#endregion 注册全局对象
app.config.globalProperties.$store = store;
app.config.globalProperties.$dayjs = dayjs;
app.config.globalProperties.$openMenu = (data) => {
  store.commit("openMenu", data);
};

import {
  judge_auth,
  buildTabIndex,
  onFocus,
  toDecimal,
  formatDecimal,
} from "@/utils/funcs";
app.config.globalProperties.$judge_auth = judge_auth;
app.config.globalProperties.$buildTabIndex = buildTabIndex;
app.config.globalProperties.$onFocus = onFocus;
app.config.globalProperties.$toDecimal = toDecimal;
app.config.globalProperties.$formatDecimal = formatDecimal;

import { phone_rules, email_rules, idcard_rules } from "@/utils/rules";
app.config.globalProperties.$phone_rules = phone_rules;
app.config.globalProperties.$email_rules = email_rules;
app.config.globalProperties.$idcard_rules = idcard_rules;

//打开文件
app.config.globalProperties.$openFile = (path) => {
  window.open(path);
};

import {
  tab_Highlinght,
  tab_TextFormat,
  tab_GroupFormat,
  tab_StatusFormat,
  tab_ShortDateFormat,
  tab_MoneyFormat,
  tab_TextAreaFormat,
  tab_PriceFormat,
  priceFormat,
  numberFormat,
  phoneFormat,
  idCardForamt,
} from "@/utils/format";

app.config.globalProperties.$tab_Highlinght = tab_Highlinght;
app.config.globalProperties.$tab_TextFormat = tab_TextFormat;
app.config.globalProperties.$tab_GroupFormat = tab_GroupFormat;
app.config.globalProperties.$tab_StatusFormat = tab_StatusFormat;
app.config.globalProperties.$tab_ShortDateFormat = tab_ShortDateFormat;
app.config.globalProperties.$tab_MoneyFormat = tab_MoneyFormat;
app.config.globalProperties.$tab_TextAreaFormat = tab_TextAreaFormat;
app.config.globalProperties.$tab_PriceFormat = tab_PriceFormat;
app.config.globalProperties.$priceFormat = priceFormat;
app.config.globalProperties.$numberFormat = numberFormat;
app.config.globalProperties.$phoneFormat = phoneFormat;
app.config.globalProperties.$idCardForamt = idCardForamt;

import base from "@/utils/base";
app.config.globalProperties.$base = base;

app
  .use(store)
  .use(router)
  .use(ElementPlus, {
    locale: zhCn,
  })
  .use(print)
  .mount("#app");

// 初始化主题色（恢复本地存储的主题）
initThemeColor();
